var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input-number',_vm._g(_vm._b({staticClass:"b-input-number",attrs:{"controls-position":"right"}},'el-input-number',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }